<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>

<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Invalid Reference Number</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
        <p>The reference number entered has restricted characters and is invalid.</p>
        <p>Following is a list of characters that are invalid.  Please update the reference number without the invalid characters.</p>

        Invalid Character(s) Entered: <span style="color:red;font-weight: bold;">{{invalidData}}</span><br /><br />

        <span>List of Invalid Characters: ` " ; : < > ? / ! &commat; # $ % ^ & * ( ) _ + =</span>
    </div>
    
</div>

<img src="../../../../assets/icons/red-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;">
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" style="background-color:#003087 !important;color:white !important">OK</button>
</div>

